import { render, staticRenderFns } from "./ContactsRegistrationFormSba.vue?vue&type=template&id=15d4d0e5&scoped=true&"
import script from "./ContactsRegistrationFormSba.vue?vue&type=script&lang=js&"
export * from "./ContactsRegistrationFormSba.vue?vue&type=script&lang=js&"
import style0 from "./ContactsRegistrationFormSba.vue?vue&type=style&index=0&id=15d4d0e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4d0e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VBtn,VCol,VContainer,VForm,VRow,VSelect})
